import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isMobileShell } from 'src/_shared/services/utils.js';
import { isHandingOff } from 'src/_shared/shell.js';
import { getShellHandoffUrl } from 'src/_shared/services/shellHandoff.js';

/**
 * Inside the ERIN mobile shell, moves a signed-in user whose company has the
 * erinai flag off this app: through /logout (the one place sign-out runs) and
 * on to the eAI portal, which LogoutComponent hands to the shell. Renders
 * nothing. (ERIN-8561)
 */
export default function ShellHandoff({ auth, currentUser }) {
	const history = useHistory();
	const { pathname } = useLocation();
	const url = isMobileShell() ? getShellHandoffUrl(currentUser?.company) : null;
	const companyId = currentUser?.companyId || currentUser?.company?.id;
	const email = currentUser?.emailAddress || undefined;

	useEffect(() => {
		if (!auth || !url || !currentUser?.id || pathname === '/logout') return;
		if (isHandingOff()) return; // already on the way
		history.replace({
			pathname: '/logout',
			state: { handoff: { url, companyId, email } },
		});
	}, [auth, url, companyId, email, currentUser?.id, pathname, history]);

	return null;
}
